import { useAuthContext } from "../../../../context-state/AuthContext";
import { useDashboardContext } from "../../../../context-state/DashboardContext";
import { getLinksByCollaborator } from "../../../../api";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { LinearLoader } from "../../../../components/linear-loader/LinearLoader";
// Fetch all promoter links before continue to the promoter routes
export const PromoterGuard = () => {
    const { user } = useAuthContext();
    const { promoterContext } = useDashboardContext();
    const { setPromoterLinks } = promoterContext;
    const [isFetched, setIsFetched] = useState(false);

    const getPromoterLinks = async (collaboratorId) => {
        try {
            setIsFetched(false);
            const response = await getLinksByCollaborator(collaboratorId);// or 
            setPromoterLinks(response.data);
        } catch (error) {
            console.error('Error fetching promoter links:', error);
            setPromoterLinks([]);
        } finally {
            setIsFetched(true);
        }
    };

    useEffect(() => {
        if (user?._id) {
            getPromoterLinks(user._id);
        }
    }, [user._id]);

    return (
        isFetched ? <Outlet /> : <LinearLoader />
    );
}; 